import type { TReduxActions } from 'shared/types/redux';
import { ECPDActions } from 'shared/constants/actionTypes/cpd';

import { ECPDDraftStatus, type ICPDState } from '../../types/redux/cpd';

const initialState: ICPDState = {
  cpdRegions: [],
  chatId: null,
  modalType: null,
  pikLandingChannel: null,
  cpdDraftStatus: ECPDDraftStatus.Init,
  cpdDraftSource: null,
  cpdDraftId: null,
  cpdChatIdLoadingStatus: null,
  cpdDealType: null,
};

export function cpdReducer(state: ICPDState = initialState, action: TReduxActions) {
  switch (action.type) {
    case ECPDActions.CHANGE_MODAL_TYPE:
      return {
        ...state,
        modalType: action.payload,
      };
    case ECPDActions.SET_CPD_PIK_LANDING_CHANNEL:
      return {
        ...state,
        pikLandingChannel: action.payload,
      };
    case ECPDActions.SET_CPD_DRAFT_SOURCE:
      return {
        ...state,
        cpdDraftSource: action.payload,
      };
    case ECPDActions.SET_CPD_DEAL_TYPE:
      return {
        ...state,
        cpdDealType: action.payload,
      };
    case ECPDActions.SET_CPD_DRAFT_ID:
      return {
        ...state,
        cpdDraftId: action.payload,
      };
    case ECPDActions.SET_CPD_DRAFT_STATUS:
      return {
        ...state,
        cpdDraftStatus: action.payload,
      };
    case ECPDActions.SET_CPD_CHAT_ID_LOADING_STATUS:
      return {
        ...state,
        cpdChatIdLoadingStatus: action.payload,
      };
    default:
      return state;
  }
}
